// extracted by mini-css-extract-plugin
export var container = "Credits_container__zEYMl";
export var item = "Credits_item__SyHGY";
export var md = "768px";
export var shared = "\"../../shared.module.css\"";
export var tooltip = "Credits_tooltip__l+RYj";